import { EMPTY_STRING } from '../../../../constants/common'

export const PROFILE_ORAG_CLUSTER_INHABITANT_DATA = {
  deposit_type: 'Complicated',
  fundings: 'Analytical',
  guaranteed_value: 'Commitment',
  notes: EMPTY_STRING,
  remedy: 'Court proceedings',
  stop_overdue_notice: 'Delay is possible for 6 months',
  termination_denied: 'Without termination rights',
  termination_time: '8 months',
  termination_timeframe: 'at the end of the second year',
}
